import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView } from '../utils/analytics';

/**
 * Custom hook that automatically tracks page views when route changes
 * Must be placed inside a component that's within the Router
 */
export const usePageTracking = () => {
  const location = useLocation();

  useEffect(() => {
    // Track page view whenever location changes
    trackPageView(
      location.pathname + location.search,
      document.title
    );
  }, [location.pathname, location.search]);
};
